import script from "./ContactPersonForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactPersonForm.vue?vue&type=script&setup=true&lang=ts"

import "./ContactPersonForm.vue?vue&type=style&index=0&id=5a93e630&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a93e630"]])

export default __exports__